import style from '../styles/form.module.css'

import classNames from 'classnames/bind'
import useTranslation from 'next-translate/useTranslation'
import { useState, useEffect } from 'react'
import useAuth from '../hooks/useAuth'

const bankAccounts = {
  SGD: {
    internal: 'DBS',
    account: '0039229747',
    bank: 'DBS Bank',
    address: '12 Marina Blvd, MBFC Tower 3, Singapore 018982',
    swift: 'DBSSSGSGXXX',
    name: 'Silver Bullion Pte Ltd'
  },
  USD: {
    internal: 'DBS',
    account: '77722200928821079',
    bank: 'Citibank',
    address: '111 Wall Street, New York, NY 10005, USA',
    swift: 'CITIUS33XXX',
    aba: '031100209',
    name: 'Silver Bullion Pte Ltd'
  },
  EUR: {
    internal: 'DBS',
    account: 'NL30CITI7003060012',
    bank: 'Citibank',
    address: 'Citibank International plc, Schiphol Boulevard 257, 1118 BH Schiphol',
    swift: 'CITINL2X',
    name: 'Silver Bullion Pte Ltd'
  },
  AUD: {
    internal: 'DBS',
    account: '79049999',
    bank: 'Citibank Australia',
    address: 'Level 25, 2 Park Street, SYDNEY, NSW 2000, Australia',
    swift: 'CITIAU2X',
    bsb: '248097',
    name: 'Silver Bullion Pte Ltd'
  },
  CAD: {
    internal: 'DBS',
    account: '3000127766',
    bank: 'Citibank N.A., Canadian branch',
    transitBranch: '20012',
    institutionNumber: '0328',
    address: '123 Front Street, Toronto, ON, M5J 2M3, Canada',
    swift: 'CITICATTBCH',
    name: 'Silver Bullion Pte Ltd'
  },
  CHF: {
    internal: 'DBS',
    account: '0039229747',
    bank: 'DBS Bank',
    address: '12 Marina Blvd, MBFC Tower 3, Singapore 018982',
    swift: 'DBSSSGSGXXX',
    name: 'Silver Bullion Pte Ltd'
  },
  GBP: {
    internal: 'DBS',
    account: '65311953',
    bank: 'World First UK Ltd',
    address: 'Millbank Tower, 21-24 Millbank, London SW1P 4QP, United Kingdom',
    swift: 'WFSTGB2L',
    iban: 'GB83WFST23682465311953',
    sortcode: '23-68-24',
    name: 'Silver Bullion Pte Ltd'
  },
  HKD: {
    internal: 'DBS',
    account: '162128058',
    bank: 'Citibank N.A., Hong Kong Branch',
    address: 'Champion Tower Three Garden Road Central, Hong Kong',
    swift: 'CITIHKHX',
    transitBranch: '20012',
    bankCode: '006',
    branchCode: '391',
    name: 'Silver Bullion Pte Ltd'
  },
  JPY: {
    internal: 'DBS',
    account: '13900001118',
    bank: 'CITIBANK N.A.SINGAPORE',
    address: '3 Changi Business Park Crescent, 07-00, Singapore 486026',
    swift: 'CITISGSG',
    bankCode: '7214',
    branchCode: '001',
    name: 'Silver Bullion Pte Ltd'
  }
}

const xfersAccount = {
  internal: 'Xfers',
  bank: 'CIMB',
  address: '50 Raffles Place, Singapore Land Tower 09-01, Singapore 048623',
  swift: 'CIBBSGSG',
  name: 'Xfers Pte Ltd'
}

export default function BankTransfer ({ id = '', active, amount, instant, recurring, currency, locale, onCopy, onSubmit, onCancel, onError }) {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)

  const { authedFetch } = useAuth()

  const [loading, setLoading] = useState(!recurring)
  const [reference, setReference] = useState(recurring ? id : undefined)
  const [account, setAccount] = useState()

  useEffect(() => {
    async function fetchRef () {
      const response = await authedFetch(`/api/transfer?amount=${amount}&id=${id}&currency=${currency}`)
      const json = await response.json()
      if (response.status !== 200) {
        onError(json.detail)
        return
      }
      if (json.XfersInstruction?.accountNo) {
        setAccount(json.XfersInstruction.accountNo)
      }
      // if (!id) {
      setReference(json.PaymentIntentId)
      // }
      setLoading(false)
    }
    !recurring && currency && active !== false && fetchRef()
  }, [active])

  const handleComplete = () => {
    onSubmit()
    authedFetch('/api/payment-intent', {
      method: 'PUT',
      body: JSON.stringify({
        PaymentIntentId: reference,
        Status: 'CustomerSent'
      })
    })
  }

  const handleCancel = () => {
    if (window.confirm(t('banktransfer-cancel-confirm'))) {
      onCancel()
      authedFetch('/api/payment-intent', {
        method: 'PUT',
        body: JSON.stringify({
          PaymentIntentId: reference,
          Status: 'Cancelled'
        })
      })
    }
  }

  const bankAccount = reference ? (account ? Object.assign(xfersAccount, { account }) : bankAccounts[currency || 'SGD']) : null

  return (
    <div className={c('transferform')} key={currency}>
      {!recurring && active !== undefined && (
        <div className={c('leadingsuccess', { success: active })}>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 70 70'>
            <path fill='#D8D8D8' d='M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z' />
            <circle stroke='#F6C358' cx='35' cy='35' r='24' strokeWidth='1.3' strokeLinecap='round' fill='transparent' />
            <polyline strong='#F6C358' strokeWidth='1.3' points='23 34 34 43 47 27' fill='transparent' />
          </svg>
        </div>
      )}
      <div>
        {!recurring ? (
          <>
            <h3>{t('banktransfer-title')}</h3>
            <p>
              {instant
                ? t('banktransfer-instant-info')
                : t('banktransfer-info')}
            </p>
          </>
        ) : (
          <>
            <h3>{t('banktransfer-recurring-title')}</h3>
            <p>{t('banktransfer-recurring-text')}</p>
          </>
        )}
        <div className={c('inputfield')}>
          <label htmlFor='recipient'>{t('banktransfer-recipient')}:</label>
          <input type='text' id='recipient' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.name} value={bankAccount?.name} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('recipient')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        <div className={c('inputfield')}>
          <label htmlFor='accountno'>{t('banktransfer-accountno')}:</label>
          <input type='text' id='accountno' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.account} value={bankAccount?.account} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('accountno')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        <div className={c('inputfield')}>
          <label htmlFor='bankname'>{t('banktransfer-bankname')}:</label>
          <input type='text' id='bankname' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.bank} value={bankAccount?.bank} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('bankname')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        <div className={c('inputfield')}>
          <label htmlFor='bankaddress'>{t('banktransfer-address')}:</label>
          <input type='text' id='bankaddress' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.address} value={bankAccount?.address} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('bankaddress')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        <div className={c('inputfield')}>
          <label htmlFor='swift'>{t('banktransfer-swift')}:</label>
          <input type='text' id='swift' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.swift} value={bankAccount?.swift} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('swift')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        {bankAccount?.aba && (
          <div className={c('inputfield')}>
            <label htmlFor='aba'>{t('banktransfer-aba')}:</label>
            <input type='text' id='aba' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.aba} value={bankAccount?.aba} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('aba')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.transitBranch && (
          <div className={c('inputfield')}>
            <label htmlFor='transitBranch'>{t('banktransfer-transit-branch')}:</label>
            <input type='text' id='transitBranch' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.transitBranch} value={bankAccount?.transitBranch} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('transitBranch')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.institutionNumber && (
          <div className={c('inputfield')}>
            <label htmlFor='institutionNumber'>{t('banktransfer-institution-number')}:</label>
            <input type='text' id='institutionNumber' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.institutionNumber} value={bankAccount?.institutionNumber} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('institutionNumber')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.bankCode && (
          <div className={c('inputfield')}>
            <label htmlFor='bankCode'>{t('banktransfer-bankcode')}:</label>
            <input type='text' id='bankCode' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.bankCode} value={bankAccount?.bankCode} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('bankCode')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.branchCode && (
          <div className={c('inputfield')}>
            <label htmlFor='branchCode'>{t('banktransfer-branchcode')}:</label>
            <input type='text' id='branchCode' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.branchCode} value={bankAccount?.branchCode} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('branchCode')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.bsb && (
          <div className={c('inputfield')}>
            <label htmlFor='bsb'>{t('banktransfer-bsb')}:</label>
            <input type='text' id='bsb' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.bsb} value={bankAccount?.bsb} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('bsb')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.sortcode && (
          <div className={c('inputfield')}>
            <label htmlFor='sortcode'>{t('banktransfer-sortcode')}:</label>
            <input type='text' id='sortcode' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.sortcode} value={bankAccount?.sortcode} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('sortcode')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        {bankAccount?.iban && (
          <div className={c('inputfield')}>
            <label htmlFor='iban'>{t('banktransfer-iban')}:</label>
            <input type='text' id='iban' className={loading ? 'loadingshimmer' : ''} readOnly key={bankAccount?.iban} value={bankAccount?.iban} />
            <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('iban')} title={t('banktransfer-copy')}>
              <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
            </button>
          </div>
        )}
        <div className={c('inputfield')}>
          <label htmlFor='amountto'>{t('banktransfer-amount')} ({currency}):</label>
          <input type='text' id='amountto' className={loading ? 'loadingshimmer' : ''} readOnly key={amount} defaultValue={(amount || 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('amountto')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
        </div>
        <div className={c('inputfield')}>
          <label htmlFor='referenceto'>{t('banktransfer-reference')}:</label>
          <input type='text' id='referenceto' className={loading ? 'loadingshimmer' : ''} readOnly defaultValue={reference} key={reference} />
          <button type='button' className={'light ' + c('copy')} onClick={() => onCopy('referenceto')} title={t('banktransfer-copy')}>
            <img src='/images/copy.svg' alt={t('banktransfer-copy-alt')} />
          </button>
          <div>{t('banktransfer-reference-info')}</div>
        </div>
        <br />
        {onSubmit && <button onClick={handleComplete}>{t('banktransfer-transfercomplete-button')}</button>}
        <br />
        <br />
        <br />
        {onCancel && <button className='light' onClick={handleCancel}>{t('banktransfer-cancel-button')}</button>}
      </div>
    </div>
  )
}
